import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

// Lazy-loaded route components
const LazyAdvancesRoute = lazy(() => retry(() => import('app/pages/admin/Reports/Advances/List')));
const LazyAdvanceRelationshipRoute = lazy(() => retry(() => import('app/pages/admin/Reports/Advances/Relationship')));
const LazyAdvancePayorRoute = lazy(() => retry(() => import('app/pages/admin/Reports/Advances/Payor')));
const LazyReportsRoute = lazy(() => retry(() => import('app/pages/admin/Reports')));
const LazyMisdirectedPaymentsRoute = lazy(() => retry(() => import('app/pages/admin/Reports/MisdirectedPayments')));
const LazyTriumphLoadAdvancesRoute = lazy(() => retry(() =>
  import('app/pages/admin/Reports/TriumphLoadAdvances/List')));
const LazyTriumphLoadAdvanceRelationshipRoute = lazy(() => retry(() =>
  import('app/pages/admin/Reports/TriumphLoadAdvances/Relationship')));
const LazyTriumphLoadAdvancePayorRoute = lazy(() => retry(() =>
  import('app/pages/admin/Reports/TriumphLoadAdvances/Payor')));
const LazyUnreconciledFundsRoute = lazy(() => retry(() => import('app/pages/admin/Reports/UnreconciledFunds/List')));
const LazyUnreconciledFundsPayorRoute = lazy(() => retry(() =>
  import('app/pages/admin/Reports/UnreconciledFunds/Payor')));

// Component wrapper types
type ComponentProps = Record<string, unknown>;

// Export component wrappers
export const Advances = (props: ComponentProps) => <LazyAdvancesRoute {...props} />;
export const AdvanceRelationship = (props: ComponentProps) => <LazyAdvanceRelationshipRoute {...props} />;
export const AdvancePayor = (props: ComponentProps) => <LazyAdvancePayorRoute {...props} />;
export const Reports = (props: ComponentProps) => <LazyReportsRoute {...props} />;
export const MisdirectedPayments = (props: ComponentProps) => <LazyMisdirectedPaymentsRoute {...props} />;
export const TriumphLoadAdvances = (props: ComponentProps) => <LazyTriumphLoadAdvancesRoute {...props} />;
export const TriumphLoadAdvanceRelationship = (props: ComponentProps) => (
  <LazyTriumphLoadAdvanceRelationshipRoute {...props} />
);
export const TriumphLoadAdvancePayor = (props: ComponentProps) => <LazyTriumphLoadAdvancePayorRoute {...props} />;
export const UnreconciledFunds = (props: ComponentProps) => <LazyUnreconciledFundsRoute {...props} />;
export const UnreconciledFundsPayor = (props: ComponentProps) => <LazyUnreconciledFundsPayorRoute {...props} />;
